"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Layout = require("../../Layout");

var _Hero = require("../Hero.style");

var HeroTextOnly = function HeroTextOnly(_ref) {
  var hero = _ref.hero,
      textColor = _ref.textColor,
      title = _ref.title,
      wrapperProps = _ref.wrapperProps;

  if (wrapperProps.mediaType) {
    return /*#__PURE__*/_react.default.createElement(_Hero.MediaWrapper, Object.assign({
      variant: "standard"
    }, wrapperProps), /*#__PURE__*/_react.default.createElement(_Hero.TextOnlyOverlay, null, /*#__PURE__*/_react.default.createElement(_Layout.Container, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
      justifyContent: "center"
    }, /*#__PURE__*/_react.default.createElement(_Hero.HeroColumn, {
      width: 12,
      variant: "standard"
    }, /*#__PURE__*/_react.default.createElement(_Hero.HeroHeadline, {
      size: hero.textOnlyTitleSize,
      textColor: textColor,
      variant: "standard"
    }, title))))));
  }

  return /*#__PURE__*/_react.default.createElement(_Hero.Wrapper, Object.assign({
    variant: "standard"
  }, wrapperProps), /*#__PURE__*/_react.default.createElement(_Hero.TextOnlyOverlay, null, /*#__PURE__*/_react.default.createElement(_Layout.Container, null, /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_Hero.HeroColumn, {
    width: 12,
    variant: "standard"
  }, /*#__PURE__*/_react.default.createElement(_Hero.HeroHeadline, {
    size: hero.textOnlyTitleSize,
    textColor: textColor,
    variant: "standard"
  }, title))))));
};

HeroTextOnly.propTypes = {
  hero: _propTypes.default.shape({
    textOnlyTitleSize: _propTypes.default.string
  }),
  textColor: _propTypes.default.string,
  title: _propTypes.default.string,
  wrapperProps: _propTypes.default.shape({
    mediaType: _propTypes.default.string
  })
};
HeroTextOnly.defaultProps = {
  hero: null,
  textColor: null,
  title: null,
  wrapperProps: null
};
var _default = HeroTextOnly;
exports.default = _default;